export default __webpack_public_path__ + "static/media/36_p._magnet.dd2860cd.png";